import { getRoverRoutes } from './rover'
import { getSherpaRoutes } from './sherpa'
import { getTerminalRoutes } from './terminal'

export const getNotificationRoutes = ({
  platform,
  ...rest
}: IGetNotificationRoutes) => {
  switch (platform) {
    case 'TERMINAL':
      return getTerminalRoutes(rest)
    case 'SHERPA':
      return getSherpaRoutes(rest)
    case 'ROVER':
      return getRoverRoutes(rest)
    case 'VENDOR':
      return ''
    default:
      return ''
  }
}
